module.exports = __webpack_public_path__ + "img/rosewood-demo.5bb19c9e.gif";